import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useMemo, useEffect, useState, useContext } from 'react';
import { ReactComponent as DeleteIcon } from 'Icons/CommandPanel/Delete_Dark.svg';
import { deleteWizardScreen, isNullOrUndefined } from 'utils/Global';
import { ScreenInfoDTO } from 'business/models/Models';
import ScreenWizardContext from './ScreenWizardContext';
import SelectScreenOptions from './SelectScreenOptions';
import TableInput from './TableInput';
import cloneDeep from 'lodash/cloneDeep';
import LayersError from 'components/customComponents/Layers/LayersError';
import './ScreenExperimentWizard.scss';

type SelectedScreensProps = {
  selectedScreens: ScreenInfoDTO[];
};
function SelectedScreen({ selectedScreens = null }: SelectedScreensProps) {
  const [data, setData] = useState([]);
  const [invalidScreens, setInvalidScreens] = useState<string[]>([]);
  const screenWizContext = useContext(ScreenWizardContext);
  const localScreens = screenWizContext.screens;
  function deleteAllScreens() {
    screenWizContext.changeScreens([]);
  }

  function deleteScreen(screen) {
    const lscreens = screenWizContext.screens;

    deleteWizardScreen(lscreens, screen);
    const tempData = getMappedData(lscreens);
    screenWizContext.changeScreens(lscreens);
    setData([...tempData]);
  }

  useEffect(() => {
    const lScreens = screenWizContext.screens;
    const dSelectedScreens = cloneDeep(selectedScreens);
    if (!isNullOrUndefined(selectedScreens)) {
      screenWizContext.changeScreens([...lScreens, ...dSelectedScreens]);
    }
  }, [selectedScreens]);

  useEffect(() => {
    const mappedData = getMappedData(localScreens);
    setData(mappedData);
  }, [localScreens]);

  useEffect(() => {
    if (invalidScreens.length > 0) {
      screenWizContext.setScreenVolError(true);
    } else {
      screenWizContext.setScreenVolError(false);
    }
  }, [invalidScreens]);
  const columns = useMemo(
    () => [
      {
        Header: 'Screen Name',
        accessor: 'name',
        className: 'rmtable-custom-style1 alignContent col-6',
        Cell: ({ cell }: any) => <div className="truncate w-[160px]">{cell.value}</div>,
      },
      {
        Header: 'Lot',
        accessor: 'screenLot',
        className: 'col-2',
      },
      {
        Header: 'Vol(µL)',
        accessor: 'volume',
        className: 'col-3',
      },
      {
        Header: (
          <DeleteIcon
            id="selectedscreen-colums-delete-icon"
            onClick={deleteAllScreens}
            className="cursor-pointer"
          />
        ),
        accessor: 'delete',
        className: 'col-2',
      },
    ],
    [],
  );
  function getErrorsView(errors: string[]) {
    return errors.map((screenName, index) => (
      <LayersError
        key={`layerError${index}`}
        style={{ padding: '10px' }}
        errorText={`${screenName}-Layer volume must in value range (0 - ${screenWizContext.plateType.volume})`}
      />
    ));
  }

  function getMappedData(dataToMap: ScreenInfoDTO[]) {
    invalidScreens.splice(0, invalidScreens.length);
    setInvalidScreens([...invalidScreens]);
    const tempData = dataToMap.map((screen) => {
      const lotOptions = [];
      screen.screenLotRows.forEach((screenlot) => {
        lotOptions.push({
          id: screenlot.id,
          name: screenlot.name,
        });
      });

      function changeInputVal(val: string) {
        const numVal = parseFloat(val);
        if (!val || numVal > screenWizContext.plateType.volume) {
          setInvalidScreens((prev) =>
            prev.includes(screen.name) ? prev : [...prev, screen.name],
          );
          return;
        }
        setInvalidScreens((prev) => prev.filter((name) => name !== screen.name));
        screen.layerVolume = numVal;
      }

      function onBlurInput(val) {
        if (!val) {
          setInvalidScreens([...invalidScreens, screen.name]);
          return;
        }
        const numVal = parseFloat(val);
        screen.layerVolume = numVal;
        screenWizContext.changeScreens([...dataToMap]);
      }
      if (
        screen.layerVolume < 0 ||
        screen.layerVolume > screenWizContext.plateType.volume
      ) {
        invalidScreens.push(screen.name);
        setInvalidScreens([...invalidScreens]);
      }
      return {
        name: screen.name,
        screenLot: (
          <SelectScreenOptions
            options={lotOptions}
            defaultValue={screen.screenLotId}
            screen={screen}
          />
        ),
        volume: (
          <TableInput
            initialValue={screen.layerVolume.toString()}
            changeInputValue={changeInputVal}
            onBlurInput={onBlurInput}
            className="h-full"
          />
        ),
        delete: (
          <DeleteIcon
            id="selectedscreen-delete-icon"
            onClick={() => deleteScreen(screen)}
            style={{ cursor: 'pointer' }}
          />
        ),
      };
    });
    return tempData;
  }

  return (
    <>
      <div
        id="selectedscreen-table-wrapper"
        style={{ display: 'flex', height: '80%', overflow: 'auto' }}
      >
        <RMTable columns={columns} data={data} />
      </div>
      <div
        id="selectedscreen-errorsview-wrapper"
        style={{ height: '20%', overflow: 'auto' }}
      >
        {getErrorsView(invalidScreens)}
      </div>
    </>
  );
}

export default SelectedScreen;
